import { Box, Card, List, ListItem, ListSubheader } from '@mui/material';
import AdminListFuzzySearch from './AdminListFuzzySearch';
import EnumListItem from './EnumListItem';
import { useState } from 'react';
import { adminCardSx, adminListScrollSx, adminSearchActionRowSx } from './adminStyles';

function EnumListComponent({
  enumItems,
  itemType,
  addButton,
  targetMergingItem,
  setEnumModalOpen,
  setIsEditing,
  setSelectedEnum,
  isMerging,
  setIsMerging,
  setMergingItems,
}) {
  const [searchResults, setSearchResults] = useState([]);
  const [selectedItems, setSelectedItems] = useState(new Set());

  const handleCheckboxChange = (event, enumItem) => {
    const updatedSelectedItems = new Set(selectedItems);
    if (event.target.checked) {
      updatedSelectedItems.add(enumItem);
    } else {
      updatedSelectedItems.delete(enumItem);
    }
    setSelectedItems(updatedSelectedItems);
    setMergingItems([...updatedSelectedItems]);
  };

  const activeItems = searchResults.filter((item) => !item.archived);
  const archivedItems = searchResults.filter((item) => item.archived);

  return (
    <Box sx={{ width: '100%' }}>
      <Card sx={adminCardSx}>
        <List
          sx={{
            ...adminListScrollSx,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            padding: '0',
            margin: '0',
            width: '100%',
          }}
          disablePadding={true}
          padding={0}
        >
          <ListItem key={'searchbar'} sx={adminSearchActionRowSx}>
            <AdminListFuzzySearch items={enumItems} setSearchResults={setSearchResults} />
            {!isMerging && addButton()}
          </ListItem>

          {activeItems &&
            activeItems.map((enumItem, i) => (
              <EnumListItem
                targetMergingItem={targetMergingItem}
                key={enumItem._id || `activeItem-${i}`}
                enumItem={enumItem}
                itemType={itemType}
                isMerging={isMerging}
                selectedItems={selectedItems}
                handleCheckboxChange={handleCheckboxChange}
                setIsEditing={setIsEditing}
                setSelectedEnum={setSelectedEnum}
                setEnumModalOpen={setEnumModalOpen}
                setIsMerging={setIsMerging}
              />
            ))}

          {archivedItems.length > 0 && (
            <ListSubheader
              sx={{
                backgroundColor: (theme) => theme.palette.whiteScaleLighter.main,
                color: 'text.secondary',
                width: 'calc(100% - 1.5rem)',
                borderRadius: '8px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mt: 1,
                mb: 0.75,
                mx: 0.75,
                py: 0.35,
              }}
            >
              Archived
            </ListSubheader>
          )}

          {archivedItems &&
            archivedItems.map((enumItem, i) => (
              <EnumListItem
                targetMergingItem={targetMergingItem}
                key={enumItem._id || `archivedItem-${i}`}
                enumItem={enumItem}
                itemType={itemType}
                isMerging={isMerging}
                selectedItems={selectedItems}
                handleCheckboxChange={handleCheckboxChange}
                setIsEditing={setIsEditing}
                setSelectedEnum={setSelectedEnum}
                setEnumModalOpen={setEnumModalOpen}
                setIsMerging={setIsMerging}
                isArchivedItem={true}
              />
            ))}
        </List>
      </Card>
    </Box>
  );
}

export default EnumListComponent;
